/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Box_Label_Freight_NoneInputs */

const vi_box_label_freight_none = /** @type {(inputs: Box_Label_Freight_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thu cước`)
};

/**

* @param {Box_Label_Freight_NoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const box_label_freight_none = /** @type {((inputs?: Box_Label_Freight_NoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Box_Label_Freight_NoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_box_label_freight_none(inputs)
});